import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ModalComponent } from "@shared/components/modal/modal.component";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { STRING_CONSTANTS } from "@config/constants/string.constants";

@Component({
  selector: "app-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"]
})
export class ImageComponent implements OnInit, AfterViewInit {
  @ViewChild("modal") private modalContent: TemplateRef<ModalComponent>;
  private modalRef: NgbModalRef;
  @Input() src: string | null;
  @Input() height: number;
  @Input() disablePreview: boolean;
  @Input() useImagePreview = true;

  @Input() ctaLabel: string = "Text to click...";
  @Input() ctaLabelClass = "";
  @Input() modalOptions: NgbModalOptions = {};

  constructor(
    private modalService: NgbModal
  ) {
  }

  UrlPreview: BehaviorSubject<string> = new BehaviorSubject<string>("");
  STRING_CONSTANTS = STRING_CONSTANTS;
  imgDefault = STRING_CONSTANTS.ICON.IC_IMG_DEFAULT;
  defaultModalOptions: NgbModalOptions = {
    centered: true,
    backdrop: "static",
    keyboard: false,
    size: "lg",
  }

  ngbModalOptions: NgbModalOptions;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.ngbModalOptions = {
      ...this.defaultModalOptions,
      ...this.modalOptions
    }
  }

  onClickPreview(url?: string) {
    if (url && !this.disablePreview) {
      this.UrlPreview.next(url);
      this.open().then();
    }
  }

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalRef = this.modalService.open(this.modalContent, this.ngbModalOptions);
      this.modalRef.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    this.modalRef.close();
  }
}
